'use client';

import { useState, useContext, createContext } from 'react';
import * as Styled from './styled';
import { EnterFullScreenIcon, ExitFullScreenIcon } from '@radix-ui/react-icons';

interface ExpandoContextType {
  isFullScreen: boolean;
  toggleFullScreen: () => void;
}

const ExpandoContext = createContext<ExpandoContextType>({
  isFullScreen: false,
  toggleFullScreen: () => {},
});

const ExpandoProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isFullScreen, setIsFullScreen] = useState(false);

  const toggleFullScreen = () => {
    setIsFullScreen(!isFullScreen);
  };

  return (
    <ExpandoContext.Provider value={{ isFullScreen, toggleFullScreen }}>
      <Styled.FullscreenExpando className={`section ${isFullScreen ? 'full-screen' : ''}`}>
        {children}
      </Styled.FullscreenExpando>
    </ExpandoContext.Provider>
  );
};

export const FullscreenToggle: React.FC<{ iconSize?: number; margin?: number; style?: React.CSSProperties }> = ({
  iconSize = 24,
  margin = 5,
  style,
}) => {
  const { isFullScreen, toggleFullScreen } = useContext(ExpandoContext);

  return (
    <Styled.FullscreenToggle onClick={toggleFullScreen} style={{ margin, ...style }}>
      {isFullScreen ? (
        <ExitFullScreenIcon height={iconSize} width={iconSize} />
      ) : (
        <EnterFullScreenIcon height={iconSize} width={iconSize} />
      )}
    </Styled.FullscreenToggle>
  );
};

export const useIsFullScreen = () => {
  const { isFullScreen } = useContext(ExpandoContext);
  return isFullScreen;
};

export default ExpandoProvider;
